export default "__VITE_ASSET__18da0ba4__"